import { useEffect, useState } from 'react'

/** Object URL for a File, revoked when the file changes or the component unmounts. */
export const useObjectUrl = (file: Maybe<File>) => {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!(file instanceof File) || file.size === 0) {
      setUrl(null)
      return
    }
    const next = URL.createObjectURL(file)
    setUrl(next)
    return () => URL.revokeObjectURL(next)
  }, [file])

  return url
}
